import { 등급색상 } from "./violationData";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-start-end",
        label: "기간",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장명",
        value: "사업장명",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: "",
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["대상년도", "발생일자", "사업장명", "위반내역"],
        },
      },
    ];
  },

  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 연도 (발급일자 기준 — 1227 집계와 동일)
    if (search.year) {
      conditions.push({ key: "body.발급일자", operator: "LIKE", value: `${search.year}-%` });
    }

    // 기간 (발생일자 범위)
    if (search.date && search.date.startDate) {
      conditions.push({ key: "body.발생일자", operator: ">=", value: search.date.startDate });
    }
    if (search.date && search.date.endDate) {
      conditions.push({ key: "body.발생일자", operator: "<", value: new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") });
    }

    // 사업장명
    if (search.사업장명 && search.사업장명.fieldName) {
      conditions.push({ key: "body.stdInfo.field_name", operator: "LIKE", value: `%${search.사업장명.fieldName}%` });
    }

    // 검색조건 (컬럼 + 키워드)
    const heads = list.getHead().map((e) => ({ [e.name]: e.key }));
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      const keyword = `%${search.column.keyword}%`;

      if (search.column.head === "부서명/업체명") {
        // 직영은 대상자.부서명, 수급업체는 업체.업체명에 저장되므로 OR 로 검색
        conditions.push({
          boolean: "AND",
          conditions: [
            { key: "body.대상자.부서명", operator: "LIKE", value: keyword },
            { key: "body.업체.업체명", operator: "LIKE", value: keyword, boolean: "OR" },
          ],
        });
      } else if (types[search.column.head]) {
        conditions.push({ key: types[search.column.head], operator: "LIKE", value: keyword });
      }
    }

    return conditions;
  },

  // 결재완료(승인)된 문서만 목록에 표시
  getOptions: () => {
    return {
      statusIds: [4],
    };
  },

  // =================================================================================================================
  getHead: () => {
    return [
      { name: "대상년도", key: "body.발급일자", style: { width: "80px" } },
      { name: "발생일자", key: "body.발생일자" },
      { name: "사업장명", key: "body.stdInfo.field_name" },
      { name: "등급", key: "body.등급", style: { width: "80px" } },
      { name: "구분1", key: "body.구분1" },
      { name: "구분2", key: "body.구분2" },
      { name: "부서명/업체명", key: "body.대상자.부서명" },
      { name: "파트명", key: "body.대상자.파트명" },
      { name: "직급", key: "body.대상자.직급" },
      { name: "이름", key: "body.대상자.이름" },
      { name: "위반내역", key: "body.위반내역.유형" },
      { name: "세부내용", key: "body.세부설명", style: { minWidth: "200px" }, textDisplay: "wrap" },
    ];
  },

  getCol: (index, value, func) => {
    try {
      const body = func.getContent(value);
      const 대상자 = body.대상자 || {};
      const 업체 = body.업체 || {};
      let i = 0;
      if (index === i++) return (body.발급일자 || "").substring(0, 4); // 대상년도 = 발급일자 기준
      if (index === i++) return body.발생일자 || "";
      if (index === i++) return (body.stdInfo && body.stdInfo.field_name) || "";
      if (index === i++) {
        if (body.등급 && 등급색상[body.등급]) {
          return { type: "colorBox", color: 등급색상[body.등급], text: body.등급 };
        }
        return body.등급 || "";
      }
      if (index === i++) return body.구분1 || "";
      if (index === i++) return body.구분2 || "";
      if (index === i++) return (body.구분1 === "직영" ? 대상자.부서명 : 업체.업체명) || 대상자.부서명 || 업체.업체명 || "";
      if (index === i++) return 대상자.파트명 || "-";
      if (index === i++) return 대상자.직급 || "-";
      if (index === i++) return 대상자.이름 || "-";
      if (index === i++) return (body.위반내역 && body.위반내역.유형) || "";
      if (index === i++) return body.세부설명 || "";
    } catch (e) {
      /* ignore */
    }
    return "";
  },

  // 등급별 행 배경색 (디자인 참조)
  getRowClass: (value) => {
    try {
      const body = JSON.parse(value.post_content).body;
      if (body.등급 === "경미") return "grade-minor";
      if (body.등급 === "주의") return "grade-warning";
      if (body.등급 === "심각") return "grade-severe";
    } catch (e) {
      /* ignore */
    }
  },
  addRowClassStyles: () => {
    const styleId = "violation-notice-row-styles";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.innerHTML = `
         html body .vs-table tr.grade-minor td,
         html body .vs-table tr.grade-minor td.sticky-column {
           background-color: #eaf9fc !important;
         }
         html body .vs-table tr.grade-warning td,
         html body .vs-table tr.grade-warning td.sticky-column {
           background-color: #fdf3e6 !important;
         }
         html body .vs-table tr.grade-severe td,
         html body .vs-table tr.grade-severe td.sticky-column {
           background-color: #fdecec !important;
         }

         html body .vs-table tr.grade-minor:hover td,
         html body .vs-table tr.grade-minor:hover td.sticky-column {
           background-color: #d9f2f8 !important;
         }
         html body .vs-table tr.grade-warning:hover td,
         html body .vs-table tr.grade-warning:hover td.sticky-column {
           background-color: #fae9d3 !important;
         }
         html body .vs-table tr.grade-severe:hover td,
         html body .vs-table tr.grade-severe:hover td.sticky-column {
           background-color: #fadddd !important;
         }

         .vs-table tr:hover {
          transform: translateY(0);
         }
       `;
      document.head.appendChild(style);
    }
  },

  getSearchKeyValue: () => {},
  getSearchKeyword: () => {},
};

export default list;
